import userInfo from "@/function/userInfo";
import * as API from "@/service/ApiConfig";

export default {
  DoGetIssuedQuotationDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedQuotationDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedInvoiceDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedInvoiceDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedReceiptDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedReceiptDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedTaxInvoiceDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedTaxInvoiceDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedCreditNoteDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedCreditNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedBillingNoteDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedBillingNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedPODashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedPODashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedExpenseDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedExpenseDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedPuchaseTaxInvoiceDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedPuchaseTaxInvoiceDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedReceivedCreditNoteDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedReceivedCreditNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedCombinePaymentNoteDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedCombinePaymentNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedPurchaseAssetDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedPurchaseAssetDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCaptureTrialBalanceByMerchant() {
    const _input = {
      merchantId: userInfo.MerchantId(),
    };

    return API.peakReportAPI
      .post("/api/DashBoard/CaptureTrialBalanceByMerchantId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedDepositReceiptDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedDepositReceiptDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetIssuedDepositPaymentDashboard(input) {
    const _input = {
      date: new Date(),
      transactionIssuedOptionType: input.transactionIssuedOptionType,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedDepositPaymentDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
